import React from 'react';
import {useTranslation} from "react-i18next";
import classNames from "classnames";

interface Props {
    className?: string;
}

const CartCounterBanner = ({className}: Props) => {
    const {t} = useTranslation();

    return (
        <div className={classNames(["counter-info-banner", className])}>
            {t("modules.cart.field.order_to_be_picked_up_at_the_counter.title")}
        </div>
    )
}

export default CartCounterBanner;